import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "sweetalert2/src/sweetalert2.scss";
import "./App.css";
import "./assets/styles/main.scss";
import "swiper/css";
import { useEffect, useState } from "react";
import GlobalContext from "./contexts/store";
import { AffContext } from "./contexts/AffiliateContext";
import { ToastContainer } from "react-toastify";
import { loadStripe } from "@stripe/stripe-js";
import getCompany from "./services/company";
import { Elements } from "@stripe/react-stripe-js";
import { Outlet, Route, Routes } from "react-router-dom";
import routes from "./routes";
import NavBar from "./layouts/NavBar";
import GtmPageViewTracker from "./components/GtmPageViewTracker";
import RJFooter from "./components/footers/RJ-Footer";
import { Container } from "react-bootstrap";
import getURLParameter from "./helpers/getURLParameter";

import { Get } from "./api/server";

function App() {
  const [company, setcompany] = useState({});
  const [events, setEvents] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [aff, setAff] = useState("");
  const affContexts = { aff, setAff };
  // eslint-disable-next-line no-unused-vars
  const [stripePromise, setStripePromise] = useState(() =>
    loadStripe("pk_live_eHPsjUYyy6mpbgQRFUWoy44x", {
      stripeAccount: "acct_1QxWWIJyqYb9yaOA",
    })
  );

  // COMMENT OUT FOR PRODUCTION TEST KEYvvv
  // const [stripePromise, setStripePromise] = useState(() =>
  //   loadStripe("pk_test_ERNCnPwW7Sbm9E4BUbPZdZqO", {
  //     stripeAccount: "acct_1QxWWIJyqYb9yaOA",
  //   })
  // );

  // COMMENT OUT FOR PRODUCTION TEST KEY^^^
  const store = { company, setcompany, events, organizations, upcomingEvents, setUpcomingEvents };

  useEffect(() => {
    async function getInitData() {
      const myCompany = await getCompany();
      setcompany(myCompany);
    }
    getInitData();
  }, []);

  useEffect(() => {
    const parm = getURLParameter("aff");
    if (parm) {
      setAff(parm);
    }
  }, []);

  useEffect(() => {
    const getEvents = async () => {
      try {
        const [response, organizations] = await Promise.all([
          Get(`/events/byCompany/getUpcomingEvents/${company?._id}`),
          Get(`/organizations/getByCompany/${company?._id}`),
        ]);
        setEvents(response);
        setOrganizations(organizations);

        // console.log('RAW EVENTS:', response);
        // console.log('ORGANIZATIONS:', organizations);
      } catch (error) {
        console.log(error);
      }
    };
    if (company?._id) {
      getEvents();
    }
  }, [company?._id]);

  // Process events to get one event from each organization, ordered by date
  useEffect(() => {
    // console.log('PROCESSING EVENTS - events:', events?.length, 'organizations:', organizations?.length);
    
    if (events && events.length > 0 && organizations && organizations.length > 0) {
      // Filter: include today/future events + events that started in the last 24h
      const now = new Date();
      // console.log('CURRENT DATE:', now);
      const cutoff = new Date(now.getTime() - 24 * 60 * 60 * 1000); // 24 hours ago

      const futureEvents = events.filter(event => {
        // Use start_date_local for consistent timezone handling
        const eventDate = new Date(event.start_date_local || event.start_date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const eventDay = new Date(eventDate);
        eventDay.setHours(0, 0, 0, 0);

        // Show event if: today or future, OR started within the last 24 hours (recent)
        const isTodayOrFuture = eventDay >= today;
        const isRecent = eventDate >= cutoff;
        const include = isTodayOrFuture || isRecent;
        // console.log(`EVENT: ${event.name} - Date: ${eventDate} - Today or future: ${isTodayOrFuture} - Recent (24h): ${isRecent} - Include: ${include}`);
        return include;
      });
      
      // console.log('FUTURE EVENTS:', futureEvents.length, futureEvents);

      // Group events by organization
      const eventsByOrganization = {};

      futureEvents.forEach(event => {
        const orgId = event.organization?._id;
        // console.log(`EVENT ORG ID: ${orgId} for event: ${event.name}`);
        if (orgId) {
          if (!eventsByOrganization[orgId]) {
            eventsByOrganization[orgId] = [];
          }
          eventsByOrganization[orgId].push(event);
        }
      });

      // console.log('EVENTS BY ORGANIZATION:', eventsByOrganization);

      // Get the earliest event from each organization
      const oneEventPerOrg = [];
      Object.values(eventsByOrganization).forEach(orgEvents => {
        if (orgEvents.length > 0) {
          // Sort events by start_date_local and take the first (earliest) one
          const sortedEvents = orgEvents.sort((a, b) => new Date(a.start_date_local || a.start_date) - new Date(b.start_date_local || b.start_date));
          oneEventPerOrg.push(sortedEvents[0]);
        }
      });

      // console.log('ONE EVENT PER ORG:', oneEventPerOrg);

      // Sort the selected events by date
      const sortedUpcomingEvents = oneEventPerOrg.sort((a, b) => new Date(a.start_date_local || a.start_date) - new Date(b.start_date_local || b.start_date));
      // console.log('FINAL UPCOMING EVENTS:', sortedUpcomingEvents);
      setUpcomingEvents(sortedUpcomingEvents);

    }
  }, [events, organizations]);

  return (
    <GlobalContext.Provider value={store}>
      <AffContext.Provider value={affContexts}>
        <Elements stripe={stripePromise}>
          <GtmPageViewTracker />
          <Routes>
            <Route path="/" element={<Layout />}>
              {routes.map((route, key) => (
                <Route
                  key={key}
                  path={route.path}
                  element={route.Element}
                  exact={route.exact}
                />
              ))}
            </Route>
          </Routes>
        </Elements>
      </AffContext.Provider>
    </GlobalContext.Provider>
  );
}

const Layout = () => {
  return (
    <div className="flex min-h-screen w-full flex-col overflow-x-clip bg-ink-800">
      <NavBar />
      <main className="flex-grow">
        <div className="w-full">
          <Outlet />
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
            toastClassName="myToast"
          />
        </div>
      </main>
      <RJFooter />
    </div>
  );
};

export default App;
